export default () => ({
    weightKg: 71.0,
    fatMassPercent: 35,
    get fatMassKg() { return this.round2dp(this.weightKg * this.fatMassPercent / 100); },
    get leanBodyMassKg() { return this.round2dp(this.weightKg - this.fatMassKg); },
    bmr: 1294,
    get tdeeSedentary() { return this.round2dp(this.bmr * 1.2); },
    yogaMobilityHoursPerWeek: 0,
    get yogaMobilityKcalPerWeek() { return this.weightKg * this.yogaMobilityHoursPerWeek * 2.5; },
    walkingHoursPerWeek: 7,
    get walkingKcalPerWeek() { return this.weightKg * this.walkingHoursPerWeek * 3; },
    metconHoursPerWeek: 0,
    get metconKcalPerWeek() { return this.weightKg * this.metconHoursPerWeek * 8; },
    weightliftingHoursPerWeek: 5,
    get weightliftingKcalPerWeek() { return this.weightKg * this.weightliftingHoursPerWeek * 3; },
    aquafitHoursPerWeek: 0,
    get aquafitKcalPerWeek() { return this.weightKg * this.aquafitHoursPerWeek * 4; },
    muayThaiHoursPerWeek: 0,
    get muayThaiKcalPerWeek() { return this.weightKg * this.muayThaiHoursPerWeek * 10; },
    get averageKcalFromExercisePerDay() {
        const totalKcalPerWeek = this.yogaMobilityKcalPerWeek + this.walkingKcalPerWeek + this.metconKcalPerWeek + this.weightliftingKcalPerWeek + this.aquafitKcalPerWeek + this.muayThaiKcalPerWeek;
        if (totalKcalPerWeek === 0) return 0;
        return this.round2dp(totalKcalPerWeek / 7);
    },
    get tdeePhuketFit() { return this.round2dp(this.tdeeSedentary + this.averageKcalFromExercisePerDay); },
    getWeightLossByPercent(percentage: number) {
        // assume percent is whole number e.g . 10 for 10%
        return this.round2dp(this.weightKg * (percentage / 100));
    },
    getKcalByWeight(weightKg: number) {
        return this.round2dp(weightKg * 7700);
    },
    getKcalDef(kcal: number) {
        return this.round2dp(this.tdeePhuketFit - kcal);
    },
    multiplyPercent(source: string, percent: number) {
        return this.round2dp(this[source] * (percent / 100));
    },
    getCarbsKcal(kcal: number, protein: number, fat: number) {
        return this.round2dp((kcal - (protein * 4) - (fat * 9)) / 4);
    },
    getDailyKcal(percent: number) {
        return this.round2dp(this.tdeePhuketFit - this.getKcalByWeight(this.getWeightLossByPercent(percent)) / 7);
    },
    getFat: function(percent: number, source: string, fatPercent: number) {
        if (source === 'kcal') {
            return this.getFatFromDailyKcal(percent, fatPercent);
        }

        return this.multiplyPercent(source, fatPercent);
    },
    getFatFromDailyKcal: function (percent: number, fatPercent: number) {
        return this.round2dp(this.getDailyKcal(percent) * (fatPercent / 100) / 9);
    },
    round2dp(value: number) { return Math.round(value * 100) / 100; },
})